export const nhomColumns = [
  {
    field: 'ma_nhom',
    headerName: 'Mã nhóm',
    width: 150
  },
  {
    field: 'ten_phan_nhom',
    headerName: 'Tên nhóm',
    width: 250
  }
];
